import { actions } from 'react-redux-form';
import { httpGet, httpPost } from '../../../../../utils/api.utils';
import { objectToListKey, newListSomeValue, getRequestUserSessionData as getUserData } from '../../../../../utils/helpers.utils';
import { QUOTATION_BANDWIDTH as QuotationBandwidth } from '../../../../../utils/constant.utils';
import { getVendorDetails } from '../../order-request.functions';

import {
    quotationLocationModelA
    , quotationSubscriptionModelA
    , quotationBusinessModelA

    //ACTIONS
    , setCountryOptions
    , setRequestTypeOptions
    , setVendorOptions
    , setCircuitTypeOptions
    , setContractTermOptions
    , setBandwidthOptions
    , setVendorSelected
    , setCircuitTypeSelected
    , setContractTermSelected
    , setBandwidthSelected
    , setOtherBandwidthField
    , setPurposeOfUseOptions
    , setVendorDetails
    , setFormSubmitted
    , resetQuotationRequest
    , setBandwidthUnit
    , setSubscriptionDetails
    , setHaveCircuitId
    , setCountries
    , setError
    , setQuotationCircuitSuggestions
} from './../../../../../constants/model-reducers/external/request/wireline-request/wireline-quotation.settings';

export const quotationLocationModelAInitialState = quotationLocationModelA;
export const quotationSubscriptionModelAInitialState = quotationSubscriptionModelA;
export const quotationBusinessModelAInitialState = quotationBusinessModelA;

const defaultState = () => ({
    countryOptions: []
    , countryList: []
    , preferredVendorOptions: []
    , nonPrefVendorOptions: []
    , requestTypeOptions: []
    , vendorOptions: []
    , allVendorSelected: false
    , circuitTypeOptions: []
    , allCircuitTypeSelected: false
    , contractTermOptions: []
    , allContractTermSelected: false
    , bandwidthOptions: []
    , allBandwidthSelected: false
    , showOtherBandwidthField: false
    , purposeOfUseOptions: []
    , bandwidthUnit: []
    ,  subscription: {}
    , vendorDetails: {
        Currency: ''
    }
    , haveCircuitId: false
    , formSubmitted: false
    , haveError: false
    , circuitSuggestions: []
});

const initialState = defaultState();

export const newQuotationActions = {
    getCountry: () => async (dispatch,state) => {
        var res= await httpGet(`external/orderRequest/getListCountryDropdown`);
        if(res.ok===false) {
            dispatch({
                type: setError,
                data: true,
            })
            dispatch({
                type: setCountries,
                data: []
            })
        } else {
            dispatch({
                type: setCountries,
                data: res
            })
        }
    },

    getQuotationFormData: () => async (dispatch, state) => {

        const { requestTypeId } = state().createRequest;

        var data = {
            RequestTypeId: requestTypeId
            , User: { ...getUserData() }
        };

        var res = await httpPost('external/orderRequest/getOrderForm', data);

        if (res != null) {
            dispatch({ type: setCountryOptions, data: res.Countries });
            dispatch({ type: setRequestTypeOptions, data: res.QuotationRequestType });
            dispatch({ type: setCircuitTypeOptions, data: res.QuotationCircuitType });

            const contractTerms = res.QuotationContractTerms.map(term=>({
                ...term,
                Value: `${term.Value} months`
            }));

            dispatch({ type: setContractTermOptions, data: contractTerms });

            const bandwidth = res.QuotationBandwidth.map(band=>({
                ...band,
                Value:`${band.Value !== "Other" ? `${band.Value} Mbps` : `${band.Value} Bandwidth`}`
            }));

            dispatch({ type: setBandwidthOptions, data: bandwidth });
            dispatch({ type: setPurposeOfUseOptions, data: res.PurposeOfUse });
            dispatch({ type: setBandwidthUnit, data: res.QuotationBandwidthUnit});
        }

    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryList } = state().quotationRequest;
        const { quotationLocationFormA } = state().form;

        dispatch(actions.change(model, value));

        dispatch(actions.change('quotationLocationFormA.country', countryList.find(x => x.Key === parseInt(value)).Value));
        dispatch(actions.change('quotationLocationFormA.quotationAddress', ''));
        dispatch(actions.change('quotationLocationFormA.quotationAddress2', ''));
        getVendors(dispatch, state);

    },
    onSubscriptionSelect: (value, propsName, objects) => (dispatch, state) => {

        const { quotationSubscriptionFormA } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData } = state().createRequest;

        let countrySelected=quotationSubscriptionFormA.country;

        if(isRequestOnBehalf) {
            countrySelected=requestOnBehalfData.Country;
        }

        if (value === '') {           
            dispatch({ type: setSubscriptionDetails, data: {} });
        } else {
           if(objects) {
            var obj = objects.find(o => o[propsName] === value);
            if (obj != null && obj.CircuitId != quotationSubscriptionFormA.circuitId) {                
                dispatch(actions.change('quotationSubscriptionFormA.quotationCircuitCode', value));
                dispatch(actions.change('quotationSubscriptionFormA.quotationCircuitId', obj.CircuitId));
                dispatch({ type: setSubscriptionDetails, data: obj });
            }
           } else {
              dispatch(actions.change('quotationSubscriptionFormA.quotationCircuitId', value));
           }
        }
    }
    // quotation subscription
    , onVendorSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        //const value = target.value;
        const { preferredVendorOptions, allVendorSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;
        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationVendorListIds
            , allVendorSelected
            , preferredVendorOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationVendorListIds', selectedItems));
       dispatch({ type: setVendorSelected, data: selectedItems.length == preferredVendorOptions.length });
    }
    , onCircuitTypeSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        const { circuitTypeOptions, allCircuitTypeSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;

        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationCircuitTypeIds
            , allCircuitTypeSelected
            , circuitTypeOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationCircuitTypeIds', selectedItems));
        dispatch({ type: setCircuitTypeSelected, data: selectedItems.length == circuitTypeOptions.length });
    }
    , onContractTermSelect: (e) => async (dispatch, state) => {
        const id = e.target.id;
        const { contractTermOptions, allContractTermSelected } = state().quotationRequest;
        const { quotationSubscriptionFormA } = state().form;

        let selectedItems = getNewSelectedValues(id
            , quotationSubscriptionFormA.quotationContractTermIds
            , allContractTermSelected
            , contractTermOptions);

        dispatch(actions.change('quotationSubscriptionFormA.quotationContractTermIds', selectedItems));
        dispatch({ type: setContractTermSelected, data: selectedItems.length == contractTermOptions.length });
    }
    , onBandwidthSelect: (value) => async (dispatch, state) => {
        const bandwidthOther = value.some(band=>band.includes("Other"))
        dispatch({ type: setOtherBandwidthField, data: bandwidthOther });
        if (bandwidthOther) {
            dispatch(actions.reset('quotationSubscriptionFormA.quotationBandwidthOther'));
            dispatch(actions.reset('quotationSubscriptionFormA.quotationBandwidthUnitId'));
        }
    }
    , onRequestTypeSelect: (model,value) => (dispatch,state) =>{
        dispatch(actions.change(model,value))    
        if(parseInt(value) === 5) {
            dispatch({type: setHaveCircuitId, data: true})
        } else {
            dispatch({type: setHaveCircuitId, data: false})
            dispatch(actions.reset('quotationSubscriptionFormA.quotationCircuitCode'));
            dispatch(actions.reset('quotationSubscriptionFormA.quotationCircuitId'));
        }
    }

    , submitRequest: () => async (dispatch, state) => {

        const { requestTypeId, isWirelineRequest, isRequestOnBehalf, requestOnBehalfData } = state().createRequest;
        const { quotationLocationFormA
            , quotationSubscriptionFormA
            , quotationBusinessFormA
        } = state().form;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.UserId;
        }

        var data = {
            // this block is temporary so that request will not fail (need refactor on the backend)
            LocationOrderModel: {
                ...quotationLocationFormA
                , isWirelineRequest: isWirelineRequest
            }
            , SubscriptionModel: {
                ...quotationSubscriptionFormA,
                QuotationCircuitId: quotationSubscriptionFormA.quotationCircuitCode !== '' ? quotationSubscriptionFormA.quotationCircuitCode : quotationSubscriptionFormA.quotationCircuitId
            }
            , BusinessJustificationModel: { ...quotationBusinessFormA }
            // end

            , User: { ...userData }
            , NoEmail: true
            , RequestTypeId: requestTypeId
        };

        dispatch({ type: setFormSubmitted, data: true });
       
        var res = await httpPost('external/orderRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
            resetForm(dispatch);
        }

        return res;
    }
    , resetQuotationForm: () => (dispatch) => {
        resetForm(dispatch);
        dispatch({ type: resetQuotationRequest, data: false });
        dispatch({ type: setFormSubmitted, data: false });
    }
    , resetQuotationSubscriptionOrBusinessForm: ({isSubscriptionForm, isBusinessForm}) => (dispatch) =>{
        if(isSubscriptionForm){
            resetSubscriptionForm(dispatch);
            dispatch({ type: setOtherBandwidthField, data: false });
        }
        if(isBusinessForm){
            resetBusinessForm(dispatch);
        }
    }
    , fetchQuotationCircuitSuggestions: (val, propsName) => async (dispatch, state) => {
            const {  
                isRequestOnBehalf, 
                requestOnBehalfData
            } = state().createRequest;

            const { 
                quotationLocationFormA,
                quotationSubscriptionFormA
             } = state().form;

            const { circuitSuggestions } = state().quotationRequest;

            var selectedValue = !!circuitSuggestions.find(v => v.CircuitId ===  quotationSubscriptionFormA.quotationCircuitId);

            if (selectedValue) {
                dispatch({ type: setQuotationCircuitSuggestions, data: [] });
                return null;
            }
             
             const empId = isRequestOnBehalf ? requestOnBehalfData.EmployeeId : sessionStorage.EmployeeID;

            var data = {
                locationCountryId: quotationLocationFormA.countryCode ?? 0,
                vendorId: quotationSubscriptionFormA.quotationVendorListIds.length > 0 ? quotationSubscriptionFormA.quotationVendorListIds : [0],
                employeeId: empId ?? 0,
                codeDetailId: quotationSubscriptionFormA.quotationCircuitTypeIds.length > 0 ? quotationSubscriptionFormA.quotationCircuitTypeIds : [0],
                searchValue: val
            }

            let res = await httpPost('external/autosuggest/getWirelineQuotationCircuitSuggestions/', data);
                        
            if (res && res.length > 0) {
                dispatch({ type: setQuotationCircuitSuggestions, data: res });
                return res;
            } else {
                dispatch({ type: setQuotationCircuitSuggestions, data: [] });
                return null;
            }
        }
}

async function getVendors(dispatch, state) {

    const { isWirelineRequest } = state().createRequest;
    const { quotationLocationFormA } = state().form;

    var data = {
        ...quotationLocationFormA
        , IsWirelineRequest: isWirelineRequest
    };

    var res = await httpPost('external/orderRequest/getVendors', data);
    if (res.ok == undefined && res.PrefVendors.length > 0) {
        dispatch({
            type: setVendorOptions
            , prefVendors: res.PrefVendors
            , nonPrefVendors: res.NonPrefVendors
        });
        if (res.PrefVendors[0].Key != 0) {
            dispatch(actions.change('wirelessSubscriptionFormA.vendorDetailId', res.PrefVendors[0].Key));
            getVendorDetails(dispatch, setVendorDetails, defaultState.vendorDetails, res.PrefVendors[0].Key);
        }
    }
}



function getNewSelectedValues(id, selectedValues, isSelectAll, options) {

    let newSelectedValues = [];
    let exist = objectToListKey(options).find(x => x == id);

    if (id == "" || exist == undefined) {
        newSelectedValues = isSelectAll ? [] : objectToListKey(options);
    } else {
        newSelectedValues = newListSomeValue(parseInt(id), selectedValues);
    }

    return newSelectedValues;
}

function resetForm(dispatch) {

    dispatch(actions.reset('quotationLocationFormA'));
    dispatch(actions.reset('quotationSubscriptionFormA'));
    dispatch(actions.reset('quotationBusinessFormA'));

}

function resetSubscriptionForm(dispatch){
    dispatch(actions.reset('quotationSubscriptionFormA'));
}
function resetBusinessForm(dispatch){
    dispatch(actions.reset('quotationBusinessFormA'));
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setCountries: {
            return {
                ...state,
                countryList: action.data
            }
        }
        case setError: {
            return {
                ...state,
                haveError: action.data
            }
        }
        case setCountryOptions:
            return {
                ...state,
                countryOptions: action.data
            };
        case setRequestTypeOptions:
            return {
                ...state,
                requestTypeOptions: action.data
            };
        case setVendorOptions:
            return {
                ...state,
                preferredVendorOptions: action.prefVendors
                , nonPrefVendorOptions: action.nonPrefVendors
            };
        case setVendorSelected:
            return {
                ...state,
                allVendorSelected: action.data
            };
        case setCircuitTypeOptions:
            return {
                ...state,
                circuitTypeOptions: action.data
            };
        case setCircuitTypeSelected:
            return {
                ...state,
                allCircuitTypeSelected: action.data
            };
        case setContractTermOptions:
            return {
                ...state,
                contractTermOptions: action.data
            };
        case setContractTermSelected:
            return {
                ...state,
                allContractTermSelected: action.data
            };
        case setBandwidthOptions:
            return {
                ...state,
                bandwidthOptions: action.data
            };
        case setBandwidthSelected:
            return {
                ...state,
                allBandwidthSelected: action.data
            };
        case setOtherBandwidthField:
            return {
                ...state,
                showOtherBandwidthField: action.data
            };
        case setPurposeOfUseOptions:
            return {
                ...state,
                purposeOfUseOptions: action.data
            };
        case setBandwidthUnit:
            return {
                ...state,
                bandwidthUnit: action.data
            }
        case setVendorDetails:
            return {
                ...state,
                vendorDetails: action.data
            };
        case setFormSubmitted:
            return {
                ...state,
                formSubmitted: action.data
            };
        case resetQuotationRequest:
            return {
                ...state,
                allVendorSelected: action.data
                , allCircuitTypeSelected: action.data
                , allContractTermSelected: action.data
                , allBandwidthSelected: action.data
                , showOtherBandwidthField: action.data
            };  
        case setSubscriptionDetails:
                return {
                    ...state
                    , subscription: { ...action.data }
                };
        case setHaveCircuitId:
                return {
                    ...state,
                    haveCircuitId: action.data
                };
        case setQuotationCircuitSuggestions:
            return {
                ...state,
                circuitSuggestions: action.data
            };
        default: return state;
    }
}